import React, { useState } from 'react'
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment'
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Required } from '../../../../components/RegEx/ValidationMessage';
import http from '../../../../config/BaseUrl';

function DuplicateForm({ duplicateEvent, setLoadingContent, setLoadingEvent, setLoadedEvent, fetchItemList, modalId }) {

  const dispatch = useDispatch()

  const [eventName, setEventName] = useState(null)
  const [startDateDefault, setStartDateDefault] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDateDefault, setEndDateDefault] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [lifeTime, setLifeTime] = useState(false)
  const htmlAttributes = { placeholder: "Select a date and time" };

  const { register, handleSubmit, setError, formState: { errors }, clearErrors } = useForm({
    mode: "onChange",
    reValidateMode: "all"
  });

  const dateStartTimeConverter = (value) => {
    setStartDate(moment(value).format('YYYY-MM-DD HH:mm'))
    setStartDateDefault(value)
    if (value) {
      clearErrors('event_start_date')
    }
  }
  const dateEndTimeConverter = (value) => {
    setEndDate(moment(value).format('YYYY-MM-DD HH:mm'))
    setEndDateDefault(value)
    if (value) {
      clearErrors('event_end_date')
    }
  }

  const checkDismisModal = () => {
    if (!eventName && !startDate && !endDate) {
      return false
    }
    else {
      return true
    }
  }

  const submitForm = (data) => {

    if (lifeTime) {
      if (!startDate || startDate === 'Invalid date') {
        setError("event_start_date", {
          type: "manual",
          message: "Event start date is required",
        });
        setTimeout(()=>{
          clearErrors(['event_start_date'])
        }, 3000)
      }
      else {  
        submitDataForm(data)        
      }  
    }
    else{
      if (!startDate || !endDate) {
        if (!startDate || startDate === 'Invalid date') {
          setError("event_start_date", {
            type: "manual",
            message: "Event start date is required",
          });
        }

        if (!endDate || endDate === 'Invalid date') {
          setError("event_end_date", {
            type: "manual",
            message: "Event end date is required",
          });
        }
        setTimeout(()=>{
          clearErrors(['event_start_date', 'event_end_date'])
        }, 3000)
      }
      else{
        submitDataForm(data)
      }
    }
  }

  const submitDataForm = (data) => {
    let eDate = lifeTime ? moment().add(200, 'y').format('YYYY-MM-DD HH:mm') : endDate
    const params = {
      ...duplicateEvent,
      event_name: data.event_name,
      event_start_date: startDate,
      event_end_date: eDate,
      life_time: lifeTime ? 1 : 0
    }
    document.getElementById(`close-${modalId}`).click();
    dispatch(setLoadingEvent(true))
    dispatch(setLoadingContent("Duplicating, Please Wait"))
    http.post('duplicate/event', params)
      .then(res => {
        dispatch(setLoadingContent("Successfully Duplicated."))
        dispatch(setLoadedEvent(true))
        dispatch(fetchItemList(res.data.event))
        setTimeout(() => {
          dispatch(setLoadingEvent(false))
          window.location.reload()
        }, 1000)
      })
      .catch(err => {
        dispatch(setLoadingContent("Duplicated Error"))
        dispatch(setLoadedEvent(true))
        setTimeout(() => {
          dispatch(setLoadingEvent(false))
        }, 5000)
      })
  }

    

  const checkLifeTime = (e) => {
    setLifeTime(e.target.checked)
  }

  return (
    <div className="modal fade" id={modalId} tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit(submitForm)}>
            <div className="modal-header">
              <h5 className="modal-title">Event Duplicate</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmFor="event_name" >Event Name<span className="pl-1 text-danger font-size-14">*</span></label>
                <input
                  type="text"
                  name="event_name"
                  placeholder="Event name"
                  value={eventName}
                  onChange={e => { setEventName(e.target.value) }}
                  className={`form-control mb-2 ${errors.event_name && 'is-invalid'}`}
                  {...register("event_name", { required: Required })}
                />
                <span className="text-danger font-size-14">{errors.event_name && errors.event_name.message}</span>
              </div>

              <div className="form-group">
                <label>Event Start Date & Time</label>
                <DateTimePickerComponent
                  format="dd-MM-yyyy hh:mm"
                  id="datetimepicker"
                  htmlAttributes={htmlAttributes}
                  cssClass="date-time-input customClass"
                  value={startDateDefault}
                  min={startDateDefault || new Date()}
                  change={e => { dateStartTimeConverter(e.value) }}
                />
                <span className="text-danger font-size-14">{errors.event_start_date && errors.event_start_date.message}</span>
              </div>

              <div className="form-group">
                <div className='d-flex align-items-center justify-content-between'>
                    <label>Event Finish Date & Time</label>
                    <div className="custom-control custom-checkbox life-time-check mb-0">
                        <input 
                            type="checkbox" 
                            className="custom-control-input" 
                            id={`${modalId}-customCheck1`}
                            checked={lifeTime ? "checked" : ""}
                            onChange={checkLifeTime} 
                        />
                        <label className="custom-control-label" htmlFor={`${modalId}-customCheck1`}>Ongoing event</label>
                    </div>
                </div>
                <DateTimePickerComponent
                  format="dd-MM-yyyy hh:mm"
                  id="datetimepicker"
                  htmlAttributes={htmlAttributes}
                  cssClass="date-time-input customClass"
                  value={endDateDefault}
                  min={startDateDefault || new Date()}
                  disabled={lifeTime}
                  enabled={!lifeTime}
                  change={e => { dateEndTimeConverter(e.value) }}
                />
                <span className="text-danger font-size-14">{errors.event_end_date && errors.event_end_date.message}</span>

              </div>
            </div>
            <div className="modal-footer">
              <button type="button" id={`close-${modalId}`} className="btn btn-secondary" data-dismiss="modal" aria-label="Close">Cancel</button>
              <button type="submit" className="btn btn-primary">Duplicate</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DuplicateForm
